import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export default function WidgetModal({ open, onClose }) {
  const [code, setCode] = useState(`<h2 style="font-family:'Cabinet Grotesk',sans-serif">Hello CreativeHub</h2>
<p>Edit this HTML widget — it will land on your active page.</p>`);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-xl" data-testid="widget-modal">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">Insert HTML widget</DialogTitle>
        </DialogHeader>
        <Textarea
          rows={10}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="font-mono text-xs"
          data-testid="widget-code-input"
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button
            className="bg-[#002FA7] hover:bg-blue-800 text-white"
            onClick={() => {
              window.commitWidgetCode(code);
              onClose();
            }}
            data-testid="widget-commit-button"
          >
            Insert widget
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
